export default __webpack_public_path__ + "static/conversion-over-time-using-trends-light-mode-f2b5973386a49ffe01503fb33dc92315.png";